import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'
import { IActivationServiceRequestModel } from '@apps-common/types/portal/service-request'

export const deleteUnitActivationById = async (id: number | null): Promise<IActivationServiceRequestModel> =>
  axios.delete(`/UnitActivation/deleteunitactivationrequestbyid?requestId=${id}`).then((res) => res.data?.data)

type Props = {
  id: number | null
}

export const useDeleteUnitActivation = (notify?: boolean, onSuccess?: (data: IActivationServiceRequestModel) => void) =>
  useMutation({
    mutationKey: ['deleteUnitActivationById'],
    mutationFn: ({ id }: Props) => deleteUnitActivationById(id),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Deleted device activation.')
      }
    },
    onError: () => {
      if (notify) {
        toastError('Failed to delete device activation, please try again.')
      }
    },
    throwOnError: false
  })
